import { render, staticRenderFns } from "./DiscoverV.vue?vue&type=template&id=1b0bf316&"
import script from "./DiscoverV.vue?vue&type=script&lang=js&"
export * from "./DiscoverV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports